import React from 'react';
import ReactDOM from 'react-dom';
import { MapModuleButton } from '../../mapmodule/MapModuleButton';
import olInteractionDragRotate from 'ol/interaction/DragRotate';
import { unByKey } from 'ol/Observable';
import styled from 'styled-components';
import { NorthIcon } from 'oskari-ui/components/icons';
var StyledIcon = styled.div.attrs(function (_ref) {
  var degrees = _ref.degrees;
  return {
    style: {
      transform: "rotate(".concat(degrees, "deg)")
    }
  };
}).withConfig({
  displayName: "MapRotatorPlugin__StyledIcon",
  componentId: "sc-17pcvsf-0"
})(["width:13px;height:13px;display:flex;justify-content:center;align-items:center;"]);
Oskari.clazz.define('Oskari.mapping.maprotator.MapRotatorPlugin', function (config) {
  var me = this;
  me._config = config || {};
  me._clazz = 'Oskari.mapping.maprotator.MapRotatorPlugin';
  me._defaultLocation = 'top right';
  me._toolOpen = false;
  me._index = 80;
  me._currentRot = null;
  me.previousDegrees = null;
  me._templates = {
    maprotatortool: jQuery('<div class="mapplugin maprotator"></div>')
  };
  me._log = Oskari.log('Oskari.mapping.maprotator.MapRotatorPlugin');
  this._dragRotate = null;
  this._removeListenerKey = null;
  this._name = 'MapRotatorPlugin';
}, {
  handleEvents: function handleEvents() {
    if (this._dragRotate) {
      // only add interaction/event handling once and not on every redrawUI()
      return;
    }
    var me = this;
    this._dragRotate = new olInteractionDragRotate();
    this.getMap().addInteraction(this._dragRotate);
    var eventBuilder = Oskari.eventBuilder('map.rotated');
    this._removeListenerKey = this.getMap().on('pointerdrag', function (e) {
      var degrees = me.getRotation();
      if (degrees !== me.getDegrees()) {
        me.rotateIcon(degrees);
        me.setDegrees(degrees);
        me._sandbox.notifyAll(eventBuilder(degrees));
      }
    });
  },
  setDegrees: function setDegrees(degree) {
    this.previousDegrees = degree;
  },
  getDegrees: function getDegrees() {
    return this.previousDegrees || 0;
  },
  rotateIcon: function rotateIcon(degrees) {
    this._renderButton(degrees);
  },
  setRotation: function setRotation(deg) {
    // if deg is number then transform degrees to radians otherwise use 0
    var rot = typeof deg === 'number' ? deg / 57.3 : 0;
    // if deg is number use it for degrees otherwise use 0
    var degrees = typeof deg === 'number' ? deg : 0;
    this.rotateIcon(degrees);
    this.getMap().getView().setRotation(rot);
    this.setDegrees(degrees);
  },
  getRotation: function getRotation() {
    var rot = this.getMap().getView().getRotation();
    // radians to degrees with one decimal
    var deg = Math.round(rot * 573) / 10;
    return deg;
  },
  _startPluginImpl: function _startPluginImpl() {
    this.setElement(this._createControlElement());
    this.setDegrees(this.getRotation());
    this.refresh();
    this.handleEvents();
    this.addToPluginContainer(this._element);
  },
  _createControlElement: function _createControlElement() {
    this._locale = Oskari.getLocalization('maprotator', Oskari.getLang() || Oskari.getDefaultLanguage()).display;
    return this._templates.maprotatortool.clone();
  },
  refresh: function refresh() {
    this._renderButton();
  },
  _renderButton: function _renderButton() {
    var _this = this;
    var degrees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getDegrees();
    var el = this.getElement();
    if (!el) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_maprotator",
      visible: this.hasUI(),
      title: this._locale.tooltip.tool,
      icon: /*#__PURE__*/React.createElement(StyledIcon, {
        degrees: degrees || 0
      }, /*#__PURE__*/React.createElement(NorthIcon, null)),
      onClick: function onClick() {
        return _this.setRotation(0);
      },
      iconActive: degrees !== 0,
      position: this.getLocation()
    }), el[0]);
  },
  /**
   * Create event handlers.
   * @method @private _createEventHandlers
   */
  _createEventHandlers: function _createEventHandlers() {
    return {
      /**
       * @method RPCUIEvent
       * will open/close coordinatetool's popup
       */
      RPCUIEvent: function RPCUIEvent(event) {
        if (event.getBundleId() === 'maprotator') {
          this._toggleToolState();
        }
      }
    };
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public redrawUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode) {
    // we don't need to do anything here any more
  },
  teardownUI: function teardownUI() {
    // detach old element from screen
    if (!this.getElement()) {
      return;
    }
    this.getElement().detach();
    this.removeFromPluginContainer(this.getElement());
  },
  hasUI: function hasUI() {
    return !this._config.noUI;
  },
  _stopPluginImpl: function _stopPluginImpl() {
    this.setRotation(0);
    this.teardownUI();
    if (this._dragRotate) {
      this.getMap().removeInteraction(this._dragRotate);
    }
    if (this._removeListenerKey) {
      unByKey(this._removeListenerKey);
    }
    this._dragRotate = null;
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});